import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import type { Booking } from "../types";

export const BookingCell = ({ booking }: { booking: Booking }) => {
  const { t } = useTranslation();
  if (!booking?.slotStartsAt) return <>-</>;
  const slotDate = format(new Date(booking.slotStartsAt), "yyyy-MM-dd");
  const psychologistName = `${booking.psychologistFirstName} ${booking.psychologistLastName}`;
  const label = psychologistName.includes("[DELETED]")
    ? t("DELETED_PSYCHOLOGIST")
    : psychologistName;

  return (
    <>
      <Typography insensitive variant="body-small">
        {slotDate}
      </Typography>
      <br />
      <Typography
        variant="body-small"
        color="GRAY_SYSTEM"
        dataTestId="header-psychologist-name"
      >
        {label}
      </Typography>
    </>
  );
};
